

import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import { setLoginPage, setForgetPasswordDetails, setSiteKey, setUserRegisterDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import Network from '../../Utils/network.js';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Swal from 'sweetalert2';
import SignUpComponent from './SignUpComponent';

class ForgetUsernameComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            siteKey: "",
            serviceId: ""
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        // Network.executeAxios("getRecaptchaSiteKey", "GET", "", (resp) => {
        //         this.props.setSiteKey("siteKey", resp.SITEKEY);
        //         this.setState({
        //             isLoading:false
        //         })
        //     });
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({
            [name]: value
        })
    }

    loginButtonClicked() {
        this.props.setLoginPage("pageName", "login");
    }
  
    fetchAccountDetails() {
        if (ValidateForm.inputFieldMandatoryCheck("forgetUsernameContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("forgetUsernameContainer", this.props.locales, false)) {
                var currentService = {}
                Network.executeAxios("fetchServiceInfoForPWL", "POST", { "serviceId": this.state.serviceId }, (fetchServiceInforesponse) => {
                    if (fetchServiceInforesponse && fetchServiceInforesponse.BillingSystem && fetchServiceInforesponse.BillingSystem.response &&
                        fetchServiceInforesponse.BillingSystem.response.dataset && fetchServiceInforesponse.BillingSystem.response.dataset.service_info) {
                        currentService = fetchServiceInforesponse.BillingSystem.response.dataset.service_info[0]
                    }

                    var profileId = ""
                    if (currentService && currentService.profile_id) {
                        profileId = currentService.profile_id
                    }

                    this.setState({ isLoading: true })
                    Network.executeAxios("forgetUsername", "POST", { "customerID": profileId }, (forgetUsernameResponse) => {
                        console.log("forgetUsernameResponse =>> ", forgetUsernameResponse);
                        if (forgetUsernameResponse.STATUS === "SUCCESS") {
                            this.props.setUserRegisterDetails("customerId", profileId);
                            if (currentService.profile_info && currentService.profile_info[0]) {
                                var params = currentService.profile_info[0];
                                // var profileContactNumber = "";
                                // if (params && params.contact_number_1) {
                                //     profileContactNumber = params.contact_number_1
                                // }

                                var retreivedUsername = forgetUsernameResponse.USERNAME;
                                this.props.setForgetPasswordDetails("retreivedUsername", retreivedUsername);
                                var generatedOtp = Math.floor(Math.random() * 90000) + 10000;
                                var dataToSendForOtp = {
                                    otp: generatedOtp,
                                    contactNum: this.state.serviceId
                                }
                                Network.executeAxios("otpAuth", "POST", dataToSendForOtp, (responseForOtp) => {
                                    if (responseForOtp.result_code && responseForOtp.result_code === "0") {
                                        this.props.setForgetPasswordDetails("profileContactNumber", this.state.serviceId);
                                        this.props.setForgetPasswordDetails("generatedOtp", generatedOtp);
                                        this.props.setLoginPage("pageName", "forgotUsernameOtpNumber")
                                    } else {
                                        Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                                        this.setState({ isLoading: false })
                                    }
                                });
                            } else {
                                Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                                this.setState({ isLoading: false })
                            }
                        } else if (forgetUsernameResponse.STATUS === "USER_NOT_EXIST") {
                            Swal.fire(this.props.locales.forgetUserNameInvalidCustomerIdSwal, "", "");
                            this.setState({ isLoading: false })
                        } else if (forgetUsernameResponse.STATUS === "FAILED") {
                            Swal.fire(this.props.locales.forgetUserNameOperationFailedSwal, "", "");
                            this.setState({ isLoading: false })
                        }

                    });
                })
            }
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetUsernameOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetUsernameOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.forgetUsernamePartComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    forgetUsernamePartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                    <div className="d-none d-sm-block d-md-none d-block col-md-12 p-0">
                        <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                            <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.loginButtonClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                        </div>
                    </div>
                    <div className="col-md-12 row py-4 m-0 my-5 d-none d-sm-block">

                    </div>

                </div>

                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-11" id="forgetUsernameContainer">
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.forgetPswUserNameTxt}</div>
                        <div className="col-md-12 pt-2 pr-0" style={{ fontSize: 16, color: '#404042', fontWeight: 600 }}>{this.props.locales.forgetPswUserNameCustomerTxt}</div>
                        <div className="col-md-12 pb-4" style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.forgetPswUserNameCustomerIDPinTxt} <span style={{ fontWeight: 500 }}>{this.props.locales.forgetPswUserNameNumberTxt}</span></div>
                        <div className="col-md-9 p-0">
                            <div className="form-group col-md-12" >
                                <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.forgetPswUserNameCustmerIDLabel}</label>
                                <Input maxLength={10} type="text" name="serviceId" autoComplete="new-password" style={{ color: '#404042' }}
                                    className="loginCredItem input_data mandatoryFieldSpecial typeNumber pt-4 pb-3" placeholder={this.props.locales.forgetPswUserNameCustmerIDPlc}
                                    onChange={(event) => this.inputValueChange("serviceId", event.target.value)}
                                    onKeyUp={(event) => this.displayLabel(event, this.state.serviceId, this.props.locales.forgetPswUserNameCustmerIDPlc)} />
                                <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                            </div>

                            {/* <div className="col-md-12 pt-3 pb-4">
                            <Reaptcha size="normal" sitekey={this.props.siteKey.siteKey} onVerify={this.onVerify} />
                        </div> */}
                            <div className="col-md-12 pt-3">
                                <Button className="loginPageLoginButton" onClick={() => { this.fetchAccountDetails() }} disabled={this.state.serviceId === "" ? true : false}>
                                    {this.props.locales.forgetPswUserNameProceedBtn}&nbsp; <FaArrowRight />
                                </Button>
                            </div>
                            <div className="d-flex pt-4 col-md-12 justify-content-center">
                                <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.loginButtonClicked() }}>{this.props.locales.singInOptionTextInSignInWithOtpPart}</div>
                            </div>
                            {/* <div className="col-md-12 mt-3" style={{fontSize:13,fontWeight:'bold',cursor:'pointer',color:'#E21736'}}
                            onClick={() => {this.forgetUserNameOtpSentToEmailTryAnotherWay()}}>
                                {this.props.locales.forgetUserNameOTPTryAnotherWayTxt}
                        </div> */}
                        </div>

                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    displayLabel(event, value, placeHolderText) {
        if (value !== "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

    forgetUserNameOtpSentToEmailTryAnotherWay() {
        this.props.setLoginPage("pageName", "forgotUsernameEmail");
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        siteKey: state.siteKey
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setSiteKey: function (key, payload) {
            dispatch(setSiteKey(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const ForgetUsernameComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgetUsernameComponent)


export default ForgetUsernameComponentContainer;
